import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CampaniaRequest} from '../../models/cotizador/request/model.data.request';
import { campanias } from '../../models/cotizador/response/model.data.response';
import IDetalleDescuento from '../../models/cotizador/IDetalleDescuento';
import IInteractionMenu from '../../models/cotizador/IInteractionMenu';
import IListDetail from '../../models/cotizador/IListDetail';

@Component({
  selector: 'app-cotizacion-multiple',
  templateUrl: './cotizacion-multiple.component.html',
  styleUrls: ['./cotizacion-multiple.component.css']
})
export class CotizacionMultipleComponent implements OnInit {

  @Input() numeroCotizacion: string = '';
  @Input() listLineaTable: IListDetail[] = [];
  @Input() formInit: FormGroup | undefined;
  @Input() detalle_descuentos: IDetalleDescuento[] = [] ;
  @Input() listDataCampania: Array<campanias> | undefined;
  @Input() dataCampania: CampaniaRequest = {
    cuenta: 0,
    tipo_solicitud: 0,
    codigo_sucursal: '',
    codigo_tipo_plan: '',
    tarifa: '',
    edad: 0,
    sexo: '',
    modelo_negocio: [],
    descripcionTarifa: ''
  };
  imgPrograma: string = '';

  interactionMenu: IInteractionMenu = {
    index: 0,
    action: false,
  };

  idCollapse = [];

  constructor() { }

  ngOnInit(): void {

  }

  /** Metodo para setear la moneda */
  valorMoneda(value: any) {
    var numero = "0";
    if (value != null && value != "") {
      value = value.toString().replace(",", "");
      numero = value;
    }
    return new Intl.NumberFormat('es-CO').format(parseInt(numero));
  }

  showItems(index: any) {
    const action = (this.interactionMenu.index === index) ? !this.interactionMenu.action : true;
    this.interactionMenu = {
      index: index,
      action: action,
    }
  }

}
